import React from 'react';

import IconRenderer from 'ui/icons/IconRenderer';
import type { IconProps } from 'ui/icons/IconRenderer';

import icon from './emenu.svg';

const IconMediafileEmenu: React.FC<IconProps> = ({ className, style }) => (
  <IconRenderer
    iconHtml={icon}
    className={className}
    style={style}
  />
);

export default IconMediafileEmenu;
